import { takeEvery, put, call, fork, all } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";

import { Client } from "../../utils/client";
import { RECORD_LOAD, recordLoadSuccess } from "./actions";
import { setError } from "../../redux-root/actions";

export function* recordLoad() {
  try {
    const planData = yield call(Client.getData, '/dvr/plan', '2');
    let scheduleData = {
      data: []
    };

    if (planData && planData.data && planData.data.accountNo) {
      scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');
    }

    yield put(recordLoadSuccess(planData.data, scheduleData.data));
  } catch (error) {
    console.log(error);

    yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  }
}

function* watchRecordLoad() {
  yield takeEvery(RECORD_LOAD, recordLoad);
}

export function* recordSaga() {
  yield fork(watchRecordLoad);
}
